import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import {
  CreateCustomer,
  CreateCustomerResponse,
  CustomerOrdersPaginatedResponse,
  CustomerPaginatedResponse,
  CustomerQueryParams,
  CustomerUpdatePayload,
  ViewCustomerResponse,
} from '@app/utils/interfaces/customer.interface';
import { ApiEndpoints } from '@app/utils/enums/api-endpoints';
import { getFilledParams } from '@app/utils/helpers/request.helpers';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  private readonly baseUrl = environment.apiBaseUrl;
  private readonly http = inject(HttpClient);

  public getCustomers(params?: CustomerQueryParams): Observable<CustomerPaginatedResponse> {
    return this.http.get<CustomerPaginatedResponse>(
      `${this.baseUrl}${ApiEndpoints.GET_CUSTOMERS}`,
      { params: getFilledParams(params) },
    );
  }

  public getCustomerOrders(
    customerId: string,
    params?: CustomerQueryParams,
  ): Observable<CustomerOrdersPaginatedResponse> {
    return this.http.get<CustomerOrdersPaginatedResponse>(
      `${this.baseUrl}${ApiEndpoints.GET_CUSTOMERS}/${customerId}/orders`,
      { params: getFilledParams(params) },
    );
  }

  public getCustomerByLoyaltyId(id: string): Observable<ViewCustomerResponse> {
    return this.http.get<ViewCustomerResponse>(
      `${this.baseUrl}${ApiEndpoints.GET_CUSTOMERS}/${id}`,
    );
  }

  public createCustomer(data: CreateCustomer): Observable<CreateCustomerResponse> {
    return this.http.post<CreateCustomerResponse>(
      `${this.baseUrl}${ApiEndpoints.CREATE_CUSTOMERS}`,
      data,
    );
  }

  public updateCustomerWithLoyaltyId(id: string, data: CustomerUpdatePayload): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}${ApiEndpoints.GET_CUSTOMERS}/${id}`, data);
  }

  public getCountries(): Observable<{ id: number; name: string }[]> {
    return this.http.get<{ id: number; name: string }[]>(
      `${this.baseUrl}${ApiEndpoints.GET_COUNTRIES}`,
    );
  }

  public deleteCustomer(customerId: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}${ApiEndpoints.DELETE_CUSTOMERS}/${customerId}`);
  }
}
